/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';

import {
    func,
    object,
    number,
} from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useDispatch } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import style from './BYOSelectedAddItemDetail.module.css';
import { trackEvent } from '../../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const BYOSelectedAddItemDetail = ({
    selectedItems, prevStep, directSteps,
}) => {
    useStyles(style);
    const dispatch = useDispatch();
    const [countList, setCountList] = useState(4);
    const [newItemObj, setNewItemObj] = useState([]);
    const [isCollapsed, setCollapsed] = useState(false);
    const handleViewMore = (count) => {
        setCollapsed(!isCollapsed);
        setCountList(!isCollapsed ? 4 : count);

        dispatch(trackEvent({
            ga_event_name: 'byo_interaction',
            eventCategory: 'BYO',
            eventAction: 'Gift Show-Hide button - clicked',
            eventLabel: isCollapsed ? 'Expanded' : 'Collapsed',

            interaction_type: 'select_item',
            byo_step: '',
            byo_item_name: isCollapsed ? 'Expanded' : 'Collapsed',
            byo_item_variant: isCollapsed ? 'Expanded' : 'Collapsed',
            byo_item_quantity: '',
        }));
    };
    useEffect(() => {
        const newArray = [];
        Object.keys(selectedItems)?.forEach((category) => {
            const items = selectedItems[category];
            Object?.entries(items).forEach((element) => {
                if (element[0] !== 'completed' && element[0] !== 'groupProductSelected') {
                    newArray.push(element[1]);
                }
            });
        });
        setCollapsed(newArray.length > 5);
        setNewItemObj(newArray);
    }, []);
    const expandViewMore = (isCollapsed ? <span>Show more</span> : <span>Show less</span>);
    return (
        <>
            <div className={style.selectedItemContainer}>
                <p className={style.heading}>{directSteps}. Pick Items</p>
                <span className={style.editButton}  role="presentation" onClick={() => prevStep(directSteps)}>Edit</span>
            </div>
            <div>
                {newItemObj.map((value, index) => ((countList >= index && value.quantity) ? <span key={value.productCode} className={style.selectedItem}>{`${ReactHtmlParser(value.productname)} x${value.quantity}`}</span> : (<></>)))}
                {newItemObj.length > 5 && <div role="presentation" className={style.listMore} onClick={() => handleViewMore(newItemObj.length)}>{expandViewMore}</div>}
            </div>
        </>
    );
};

BYOSelectedAddItemDetail.propTypes = {
    selectedItems: object,
    prevStep: func.isRequired,
    directSteps: number,
};

BYOSelectedAddItemDetail.defaultProps = {
    selectedItems: {},
    directSteps: 2,
};

export default BYOSelectedAddItemDetail;
